import { createAsyncThunk } from '@reduxjs/toolkit';

export const retrieveAllserveurType = createAsyncThunk(
	'[serveur-TYPE] retrieveAllserveurType',
	async (_: void, thunk: any) => {
		try {
			return  thunk.extra.serveurTypeQuery.all();
		} catch (error: any) {
			return thunk.rejectWithValue({ message: error.message ?? null });
		}
	}
);
